import { LinkButton, ErrorPanel, Progress } from '@backstage/core-components';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { useApi } from '@backstage/frontend-plugin-api';
import { Grid, Typography } from '@material-ui/core';
import useAsync from 'react-use/esm/useAsync';

const TIPOS: ReadonlyArray<{ kind: string; etiqueta: string }> = [
  { kind: 'Domain', etiqueta: 'Dominios' },
  { kind: 'System', etiqueta: 'Sistemas' },
  { kind: 'Component', etiqueta: 'Componentes' },
  { kind: 'API', etiqueta: 'APIs' },
  { kind: 'Resource', etiqueta: 'Recursos' },
];

export function SystemsMapWidgetContent() {
  const catalogApi = useApi(catalogApiRef);

  const { value, loading, error } = useAsync(async () => {
    const conteos = await Promise.all(
      TIPOS.map(tipo =>
        catalogApi.queryEntities({ filter: { kind: tipo.kind }, limit: 1 }),
      ),
    );
    return TIPOS.map((tipo, indice) => ({
      ...tipo,
      total: conteos[indice].totalItems,
    }));
  }, [catalogApi]);

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return <ErrorPanel error={error} />;
  }

  return (
    <>
      <Grid container spacing={2}>
        {(value ?? []).map(tipo => (
          <Grid item xs={6} sm={4} key={tipo.kind}>
            <Typography variant="h5">{tipo.total}</Typography>
            <Typography variant="body2" color="textSecondary">
              {tipo.etiqueta}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <LinkButton to="/catalog-graph" variant="outlined" color="primary">
        Abrir grafo de relaciones
      </LinkButton>
    </>
  );
}

export const systemsMapWidget = HomePageWidgetBlueprint.make({
  name: 'systems-map',
  params: {
    name: 'systems-map',
    title: 'Mapa de sistemas',
    components: async () => ({ Content: SystemsMapWidgetContent }),
  },
});
